import React from "react";
import { observer } from "mobx-react";
import { NikoFacilityOrderNewFlowInventoryPreviewTemplate } from "themes/application/niko-facility-order-inventory/pages";
import { NikoFacilityOrderNewFlowInventoryPreviewViewStore } from "application/niko-facility-order-inventory/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new NikoFacilityOrderNewFlowInventoryPreviewViewStore(rootStore), "nikoFacilityOrderNewFlowInventoryPreviewViewStore")
@observer
class NikoFacilityOrderNewFlowInventoryPreview extends React.Component {
	render() {
		return <NikoFacilityOrderNewFlowInventoryPreviewTemplate {...this.props} />;
	}
}

export default NikoFacilityOrderNewFlowInventoryPreview;